import UserHeader from "./UserHeader";
import AppLoader from "./AppLoader";
import { useNavigate } from "react-router-dom";

function Header({ user }) {
  const navigate = useNavigate();
  const userRole = user?.role ?? null;
  if (userRole === null) {
    navigate("./Login");
    return <AppLoader />;
  }

  return (
    <>
      {userRole === "Admin" ? (
       <div/>
      ) : (
        <UserHeader user={user} />
      )}
    </>
  );
}

export default Header;
